export enum EnumStepNames {
  SET_GENRES = 'Set genres',
  SET_REACH = 'Set reach',
  START_CAMPAIGN = 'Start campaign',
}

export interface StepsProps {
  currentStep: number
  setCurrentStep: (step: number) => void
}
